<template>
  <div v-if="package" class="banner-popup">
    <div v-if="active === 3" class="mask"></div>
    <div :class="['popup', {'active2': active >= 2}, {'active3': active === 3}]">
      <img class="expand-collapse" src="/static/activityImg/open.svg" alt="expand-collapse" @click="expandCollapse">
      <div class="content" @click="goto">
        <img class="theme" src="/static/activityImg/theme.png" alt="theme">
        <div class="package-info">
          <div v-if="active >= 2" class="name-type">
            {{ getPackageName(package.name) }}
          </div>
          <div v-if="active >= 2" class="given-days">
            <span v-if="package.given_days > 0">{{ getGivenMonthsOrDays(package.given_days) }}</span>
          </div>
          <div class="price">
            <p class="price-box">
              <span>{{ $t(currentSymbol) }}</span><span>{{ package.device_average_price }}</span>
            </p>
            <p class="month-device">/{{ $t("month") }}/{{ $t("device") }}</p>
          </div>
          <div class="off-box">
            <span>{{ getDiscount(package) }}</span>
            <span>OFF</span>
          </div>
          <p v-if="active >= 2" class="sale-price">
            <span class="origin-price" v-if="package.price !== package.list_price">{{ $t(currentSymbol) }}{{ package.list_price }}</span>
            <span>{{ $t(currentSymbol) }}{{ package.price }}</span>
          </p>
          <button>{{ $t("getNow") }}</button>
          <CountDown
            v-if="active >= 2 && (package.can_topup || package.can_subscribe)"
            :end-time="package.expired_at"
          />
        </div>
        <img class="get" src="/static/activityImg/ic_right.svg" alt="get">
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import locales from "../dashboard/choosePackage/lang"
import CountDown from "../../views/home/choosePackage/countDownNew.vue"
export default {
  name: 'BannerPopup',
  data() {
    return {
      bodyEle: null,
      recommendedPackages: null,
      package: null,
      active: 1, // 1(collapse), 2(expand), 3(popup)
      timer: null,
      active3_showNum: 0
    }
  },
  locales,
  components: {
    CountDown
  },
  computed: {
    ...mapState({
      hasToken: state => state.hasToken,
      currentLang: state => state.currentLang,
      currentSymbol: state => state.currentSymbol,
      allPackages: state => state.allPackages,
      userCurrentDevice: state => state.user.max_device_count
    })
  },
  created() {
    this.loadPackages()
  },
  mounted() {
    this.bodyEle = document.querySelector('body')
    this.timer = setTimeout(() => {
      this.active = 3
    }, this.showPopupTime());
  },
  beforeDestroy() {
    clearTimeout(this.timer)
  },
  watch: {
    hasToken(val) {
      this.getPackage()
    },
    active(val) {
      if (val === 3) {
        this.bodyEle.style.overflow = "hidden"
      } else {
        this.bodyEle.style.overflow = "auto"
      }
    }
  },
  methods: {
    goto() {
      if (this.active === 3) {
        this.bodyEle.style.overflow = "auto"
      }
      localStorage.setItem('isActivityPackage', true)
      let url = this.hasToken ? '/dashboard' : '/login'
      this.$router.push(url)
    },
    showPopupTime() {
      let time = 0
      switch (this.active3_showNum) {
        case 0:
          time = 10000
          break
        case 1:
          time = 180000
          break
        case 2:
          time = 300000
          break
        case 3:
          time = 900000
          break
        default:
          time = 1800000
          break
      }
      this.active3_showNum++
      return time
    },
    expandCollapse() {
      if (this.active === 1) {
        this.active = 2
      } else {
        if (this.active === 3) {
          this.timer = setTimeout(() => {
            this.active = 3
          }, this.showPopupTime());
        }
        this.active = 1
      }
    },
    loadPackages() {
      this.$http.get("api/v2/topup-packages", {
        headers: {
          "Cache-Control": "no-cache",
        },
      })
      .then((response) => {
        this.recommendedPackages = response.body.data.filter(p => p.is_recommended)
        this.getPackage()
      });
    },
    getPackage() {
      if (this.hasToken) {
        this.package = this.recommendedPackages.filter(p => this.userCurrentDevice <= p.device_count)[0]
      } else {
        this.package = this.recommendedPackages[0]
      }
    },
    getDiscount(pkg) {
      if (pkg.list_price) {
        return (100 - (pkg.price / pkg.list_price) * 100).toFixed(0) + "%";
      }
    },
    getPackageName(name) {
      return name.split("（")[0] || "";
    },
    getGivenMonthsOrDays(days) {
      const months = parseInt(days / 30);
      if (days < 30) {
        return `${
          window.innerWidth < 767 || this.currentLang === "en"
            ? this.$tc("new_off_text_day", 0)
            : this.$tc("new_off_text_day", 0)
        } ${days} ${
          days <= 1
            ? this.$tc("new_off_text_day", 1)
            : this.$tc("new_off_text_day", 2)
        }`;
      }
      return `${
        window.innerWidth < 767 || this.currentLang === "en"
          ? this.$tc("new_off_text", 0)
          : this.$tc("new_off_text", 0)
      } ${months} ${
        months <= 1 ? this.$tc("new_off_text", 1) : this.$tc("new_off_text", 2)
      }`;
    }
  }
}
</script>

<style lang="scss">
  @import './BannerPopup.scss';
</style>


// WEBPACK FOOTER //
// BannerPopup.vue?7e8f590f